export default __webpack_public_path__ + "static/media/code_snap.d8310ad8.webp";